<template>
  <v-container
    v-if="currentProfile"
    style="background: white !important;"
    fill-height
    fluid
  >
    <v-layout justify-center wrap>
      <v-container
        grid-list-xl
        class="pageContent"
        style="border-bottom:2px solid #4cc8ed;padding-bottom:50px"
      >
        <v-layout row wrap align-center>
          <v-flex xs12 sm6 class="text-xs-center text-sm-left">
            <div class="headline font-weight-thin">
              {{ currentProfile.name }}
            </div>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap class="mt-1">
              <v-flex xs12 sm6 lg4>
                <v-img :src="currentProfile.imageUrl" width="100%" />
                <v-container>
                  <v-layout column align-center justify-center>
                    <v-btn
                      :href="`http://${currentProfile.website}`"
                      class="info"
                      >Learn more about us here
                    </v-btn>
                    <!--                    <div class="headline heading">-->
                    <!--                      <v-btn large color="#4dc8ed" @click="emailFormDialog = true">-->
                    <!--                        <v-icon left>mdi-email-outline</v-icon>-->
                    <!--                        EMAIL NOW-->
                    <!--                      </v-btn>-->
                    <!--                    </div>-->
                  </v-layout>
                </v-container>
              </v-flex>
              <v-flex xs12 sm6 lg8>
                <div class="headline heading">Who we are</div>
                <div class="body-1">{{ currentProfile.aboutUs }}</div>
                <div class="headline heading mt-4">What we do</div>
                <div class="body-1">{{ currentProfile.whatWeDo }}</div>
                <v-layout row wrap class="pa-3">
                  <v-flex
                    v-for="(service, index) in currentProfile.services"
                    :key="`service_${index}`"
                    class="pa-0"
                    xs12
                    sm6
                  >
                    <li>{{ service }}</li>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    formData: {},
    profile_id: null,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      goodCauses: "goodCauses/approved",
      currentProfile: "goodCauses/currentProfile",
    }),
  },
  created() {
    this.$nextTick(function() {
      this.profile_id = this.$route.params.id;
      this.$store.dispatch("goodCauses/loadProfile", this.$route.params.id);
    });
  },
};
</script>

<style scoped>
.heading {
  color: #4dc8ed;
}

.application {
  background-color: white !important;
}

.sectionHeader {
  border-bottom: 1px solid #4dc8ed;
  color: #4dc8ed;
}

.nl2br {
  white-space: pre;
}

#silentbox-overlay__description {
  color: #000;
  background: rgb(77, 200, 237);
  padding: 5px;
  border: 1px solid white;
  font-size: 14pt !important;
}
</style>
